import type CheckpointDetailsData from "~~/api/response/data/checkpoint/DetailsData";
import QueuesDetails from "~/dto/queue/QueuesDetails";

export default class CheckpointDetails {
  checkpointCode: string;
  carsQueues: QueuesDetails | null;
  motorcyclesQueues: QueuesDetails | null;

  constructor(data: CheckpointDetailsData) {
    this.checkpointCode = data.checkpoint_code;
    this.carsQueues = data.cars_queues
      ? new QueuesDetails(data.cars_queues)
      : null;
    this.motorcyclesQueues = data.motorcycles_queues
      ? new QueuesDetails(data.motorcycles_queues)
      : null;
  }
}
